import {
  getAllRequestEmailThreads,
  getRequestEmailThreads,
} from '../../../../api'
import { FILE_SCOPE_REQUEST } from '../../../../constants/file'
import { PAGINATION_ALL_ITEMS_SIZE } from '../../../../constants/pagination'
import { EmailAttachedThreadsModal } from '../../../Email'
import { updateTask } from '../../Task.api'
import {
  getAllEmailThreadsFromResponse,
  getAttachedEmailThreads,
  getEmailThreadsFromResponse,
} from '../../Task.utils'

export function useTaskTableAttachEmailThreads(props) {
  function getHandleAttachEmailsThreads(id) {
    return async threads => {
      return updateTask({ request_threads: threads }, id)
        .then(() => {
          props.onAddSuccessNotification('Notification.CommonTitleSavedKey')
          props.onReload()
        })
        .catch(() => props.onAddErrorNotification('Error.AttachedEmailThreads'))
        .finally(() => props.onCloseModal())
    }
  }

  function getHandleLoadAttachedEmailThreads(requestId, activityId) {
    return () =>
      getRequestEmailThreads(requestId, {
        activity: activityId,
        page_size: PAGINATION_ALL_ITEMS_SIZE,
      })
  }

  function getHandleLoadAllEmailThreads(requestId, activityId) {
    return () =>
      getAllRequestEmailThreads(requestId, {
        activity_id: activityId,
      })
  }

  function handleAttachEmails(requestId, activityId) {
    props.setModal(
      <EmailAttachedThreadsModal
        attachedFilesProps={{ scope: FILE_SCOPE_REQUEST, subject: requestId }}
        entityId={requestId}
        getAllItemsFromResponse={getAllEmailThreadsFromResponse}
        getAttachedEmailThreads={getAttachedEmailThreads}
        getItemsFromResponse={getEmailThreadsFromResponse}
        loadAllItems={getHandleLoadAllEmailThreads(requestId, activityId)}
        loadAttachedItems={getHandleLoadAttachedEmailThreads(
          requestId,
          activityId
        )}
        loadItems={getRequestEmailThreads}
        onAttach={getHandleAttachEmailsThreads(activityId)}
        onClose={props.onCloseModal}
      />
    )
  }

  return {
    handleAttachEmails,
  }
}
